import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { forkJoin } from 'rxjs';

import { BrigadesService } from '../brigades/brigades.service';
import { EmployeeStatusesService } from '../employee-statuses/employee-statuses.service';
import { TicketsAssignService } from '../tickets-assign/tickets-assign.service';
import { AuthService } from '../../../../auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class MonitoringService {
  constructor(
    private http: HttpClient,
    private brigadesService: BrigadesService,
    private employeeStatusesService: EmployeeStatusesService,
    private ticketsService: TicketsAssignService,
    private authService: AuthService,
  ) {}

  getCurrentTime(params) {
    return this.http.get(`/admin/sectors/sector_time/`, { params: params });
  }

  getTicketStatuses(params) {
    return this.http.get(`/admin/tickets/on_brigade/`, { params: params });
  }

  getTicketStatusesGRS(params) {
    return this.http.get(`/brigade_rms/departure/on_brigade/`, { params: params });
  }


  getTickets(params) {
    return this.http.get(`/admin/monitoring/tickets/`, { params: params });
  }

  getTicketsGRS(params) {
    return this.http.get(`/admin/monitoring/departures/`, { params: params });
  }

  getTicketsUnion(params) {
    const s = this.authService.isGRSUser()
      ? this.getTicketStatusesGRS(params)
      : this.getTicketStatuses(params);

    const t = this.authService.isGRSUser()
      ? this.getTicketsGRS(params)
      : this.getTickets(params);

    return forkJoin([s, t]);
  }

  getMonitoringDataUnion({ search, ...params }) {
    const { ticket_type, sector_id, groups } = params;
    const brigadesParams = Object.assign({}, { search, ...params });

    const brigadesFilter = this.brigadesService.getUnassignedWorkers({ sector_id, groups });
    const employers = this.employeeStatusesService.getFilterStatuses(brigadesParams);
    const ticketsFilter = this.ticketsService.getTicketsStatus({ sector_id, ticket_type_id: ticket_type });
    const currentTime = this.getCurrentTime({ sector_id, groups });

    return forkJoin([brigadesFilter, employers, ticketsFilter, currentTime]);
  }
}
